import { render, staticRenderFns } from "./ArrayFieldtype.vue?vue&type=template&id=75e53f6c&"
import script from "./ArrayFieldtype.vue?vue&type=script&lang=js&"
export * from "./ArrayFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports